import { render, staticRenderFns } from "./BaseReport.vue?vue&type=template&id=2fa6d17f&scoped=true&"
import script from "./BaseReport.vue?vue&type=script&lang=js&"
export * from "./BaseReport.vue?vue&type=script&lang=js&"
import style0 from "./BaseReport.vue?vue&type=style&index=0&id=2fa6d17f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa6d17f",
  null
  
)

export default component.exports